/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Exclusive_RepresentationInputs */

const cs_enum_exclusive_representation = /** @type {(inputs: Enum_Exclusive_RepresentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výhradní zastoupení`)
};

const en_enum_exclusive_representation = /** @type {(inputs: Enum_Exclusive_RepresentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exclusive representation`)
};

/**
* | output |
* | --- |
* | "Exclusive representation" |
*
* @param {Enum_Exclusive_RepresentationInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_exclusive_representation = /** @type {((inputs?: Enum_Exclusive_RepresentationInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Exclusive_RepresentationInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_exclusive_representation(inputs)
	return cs_enum_exclusive_representation(inputs)
});